export default __webpack_public_path__ + "static/media/resaneh.aa008feb.png";